export default {
  EXIBIR_CONSULTA_LEGISLACAO: false
}



// WEBPACK FOOTER //
// ./src/constants/ba/dadosEstado/analise.js